// extracted by mini-css-extract-plugin
module.exports = {"formSection":"education_formSection__3w2Lt","content":"education_content__2jdKJ","input":"education_input__212us"};